import { render, staticRenderFns } from "./mis-datos.vue?vue&type=template&id=1ecab400&"
import script from "./mis-datos.vue?vue&type=script&lang=js&"
export * from "./mis-datos.vue?vue&type=script&lang=js&"
import style0 from "./mis-datos.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports